import { ActiveFilter } from "./types";

export const activeFiltersCount = 1;

export const extractActiveFilters = (queryParams: any) => {
  let activeFilters = [];

  for (let pair of queryParams.entries()) {
    const name = pair[0];
    const value = pair[1];
    if (name === "page") {
      continue;
    }

    activeFilters.push({
      name,
      activeFilters: name === "price" ? [value] : value.split(","),
    });
  }

  return activeFilters;
};

export const getActiveFiltersByName = (
  filterName: string,
  activeFilters: ActiveFilter[]
): string[] => {
  const filterByName = activeFilters.find(
    (filter) => filter.name === filterName
  );

  if (filterByName) {
    return [...filterByName?.activeFilters];
  }

  return [];
};

export const removeEmptyStrings = (element: string) => {
  return element !== "";
};

export const getActiveFiltersCount = (filters: ActiveFilter[]): number => {
  return filters
    .map((currFilter) => {
      return currFilter.activeFilters.filter(removeEmptyStrings).length;
    })
    .reduce((acc, curr) => acc + curr, 0);
};
